export const getNoPriceText = (isYes: boolean, platformName: string): string =>
  `${platformName} isn't quoting a ${isYes ? "YES" : "NO"} price right now`;
